module.exports = __webpack_public_path__ + "img/close.a0aea2b0.svg";